import React, { Component } from "react"
import PropTypes from "prop-types"
import { push, goBack } from "react-router-redux"
import { Router } from "react-router"
import {
  handleParams,
  replaceParams,
  login,
  getUser,
  redirectAuthedIfNeeded,
  redirectUnAuthedIfNeeded,
  redirectIfNeeded,
  showIntegration
} from "./user/actions"
// import { LOCATION_CHANGE } from "./reducer";
const queryString = require("query-string")

const isOnPublicOnly = pathname => {
  const publicOnly = ["signup", "login", "password_resets", "start"]
  return publicOnly.some(x => pathname.includes(x))
}

const isOnPublicAndPrivate = pathname => {
  const publicAndPrivate = ["manage_email_subscriptions", "splash_message"]
  return publicAndPrivate.some(x => pathname.includes(x))
}

class ConnectedRouter extends Component {
  static propTypes = {
    store: PropTypes.object,
    history: PropTypes.object.isRequired,
    children: PropTypes.node,
    isSSR: PropTypes.bool
  }

  static contextTypes = {
    store: PropTypes.object
  }

  handleLocationChange = location => {
    const { getState, dispatch } = this.store
    const { isAuthenticated, token_id } = getState().models.user
    const hasAuthCookie = isAuthenticated
    const hasUserData = !!token_id
    const isOnPublicOnlyPath = isOnPublicOnly(location.pathname)
    const isOnPublicAndPrivatePath = isOnPublicAndPrivate(location.pathname)

    if (hasAuthCookie && !hasUserData) this.store.dispatch(getUser())

    if (location.search) {
      const parsed = queryString.parse(location.search)

      if (parsed.slt) {
        // dispatch({type:'@@router/LOCATION_REMOVE_PARAM', payload: 'slt'})
        !hasAuthCookie && dispatch(login({ single_login_token: parsed.slt }))
      }
      if (parsed.new_account_token) {
        dispatch({
          type: "@@router/LOCATION_REMOVE_PARAM",
          payload: "new_account_token"
        })
        // NOTE dont need if redirect back.
        // dispatch(showIntegration(parsed.new_account_token))
      }
    }

    this.store.dispatch({
      type: "@@router/LOCATION_CHANGE",
      payload: {
        ...location,
        hasAuthCookie,
        hasUserData,
        isOnPublicOnlyPath,
        isOnPublicAndPrivatePath
      }
    })

    // this.store.dispatch(handleParams())
    this.store.dispatch(redirectIfNeeded())

    // TODO compare to update location final time if doesnt replicate current state
    // const routerLoc = getState().router.location
    // if (location!==routerLoc) this.store.dispatch({
    //   type: 'compare to history.location',
    //   location,
    //   routerLoc
    // });
  }

  componentWillMount() {
    const { store: propsStore, history, isSSR } = this.props
    this.store = propsStore || this.context.store

    if (!isSSR)
      this.unsubscribeFromHistory = history.listen(this.handleLocationChange)

    this.handleLocationChange(history.location)
  }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory()
  }

  render() {
    return <Router {...this.props} />
  }
}

export default ConnectedRouter



// WEBPACK FOOTER //
// ./src/ConnectedRouter.js